import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { CategoryService } from 'src/app/api/catalog/category.service';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { LoungesService } from 'src/app/api/restaurant/lounges.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-lounges-form',
  templateUrl: './lounges-form.component.html',
  styleUrls: ['./lounges-form.component.css']
})
export class LoungesFormComponent implements OnInit {
  branchofficeSlug: string = '';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private loungesService: LoungesService,
    private route: ActivatedRoute,
    private alertifyMsg: AlertifyHelper,
    private navigationTrackerService: NavigationTrackerService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.route.snapshot.params['id'];
    this.item = this.fb.group({
      description: ['', [Validators.required, Validators.minLength(2)]],
      capacity: [null]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    if (this.isEdit) {
      this.editData();
    }
    this.navigationTrackerService.initializeMenu(this.route);
  }

  editData() {
    this.loungesService.get(this.checkId).subscribe({
      next: (data: any) => {
        this.item.setValue({
          description: data.data.description,
          capacity: data.data.capacity
        });
      }
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));

      if (this.isEdit) {
        formData.append('id', JSON.stringify(this.checkId));
        this.loungesService.updateSave(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro actualizado con éxito');
            this.cancel();
          }
        });
      } else {
        this.loungesService.save(formData).subscribe({
          next: (data: any) => {
            this.alertifyMsg.success('Registro realizado con éxito');
            this.cancel();
          }
        });
      }
    }
  }

  // onSubmit() {
  //   this.submitted = true;
  //   if (this.item.invalid) {
  //     return;
  //   }
  //   if (this.validate()) {
  //     if (this.isEdit) {
  //       this.loungesService.update(this.checkId, this.item.value).subscribe({
  //         next: (data: any) => {
  //           this.alertifyMsg.success('Registro actualizado con éxito');
  //           this.router.navigate([
  //             this.branchofficeSlug + '/restaurante/ambientes_mesas/lista'
  //           ]);
  //         }
  //       });
  //     } else {
  //       this.loungesService.save(this.item.value).subscribe({
  //         next: (data: any) => {
  //           this.alertifyMsg.success('Registro realizado con éxito');
  //           this.router.navigate([
  //             this.branchofficeSlug + '/restaurante/ambientes_mesas/lista'
  //           ]);
  //         }
  //       });
  //     }
  //   }
  // }

  validate() {
    return true;
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/restaurante/ambientes_mesas/lista'
    ]);
  }
}
